export default __webpack_public_path__ + "static/media/02-two-by-two.32d200e3.svg";